import React, { useState } from 'react';
import { Button, Image } from 'antd';
import { CameraOutlined } from '@ant-design/icons';

const RoomGallery = ({ images, title }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {/* The Trigger Button */}
      <Button 
        type="default" 
        icon={<CameraOutlined />} 
        onClick={() => setVisible(true)}
        style={{ borderColor: '#d4af37', color: '#d4af37' }}
      >
        View Gallery
      </Button>

      {/* Hidden Gallery - Triggers when visible is true */}
      <div style={{ display: 'none' }}>
        <Image.PreviewGroup
          preview={{
            visible,
            onVisibleChange: (vis) => setVisible(vis),
          }}
        >
          {images.map((img, index) => (
            <Image 
              key={index} 
              src={img} 
              alt={`${title} gallery image ${index + 1}`} 
            />
          ))}
        </Image.PreviewGroup>
      </div>
    </>
  );
};

export default RoomGallery;